import { useCallback, useContext } from 'react';

import { RequestFilter } from 'proto/Search/KiFilter/RequestFilter';
import { RequestFilterGroup } from 'proto/Search/KiFilter/RequestFilterGroup';

import { AiSmartFilterContext } from '../__context/AiSmartFilterProvider';

export const useAiSmartFilterData = () => {
    const ref = useContext(AiSmartFilterContext);

    return useCallback((): RequestFilterGroup[] => {
        const filterData = ref.current;

        return Object.values(filterData)
            .filter((group) => group.isVisible)
            .map((group) => {
                const requestFilters: RequestFilter[] = Object.values(
                    group.filters
                )
                    .filter((filter) => filter.value !== '')
                    .map((filter) => ({
                        hasCount: filter.hasCount ?? false,
                        label: filter.label,
                        urlKey: filter.urlKey,
                        value: filter.value,
                        count: filter.count ?? 0,
                        minPrice: filter.price ?? 0,
                        isDisabled: !filter.isSelectable,
                    }));

                return {
                    label: group.label,
                    multi: group.multi ?? false,
                    minLogic: group.minLogic ?? false,
                    requestFilters,
                };
            })
            .filter((group) => group.requestFilters.length);
    }, [ref]);
};
